// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1TuQg","label":"Category_label__1Jq6g","content":"Category_content__3vqlq","header":"Category_header__2JgUR","location":"Category_location__Zz5Ml"};